export const generatedBetaReviewDocket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-beta-review-docket",
  "operatingRule": "Human and external approvals must be represented as hash-backed signoff slots. The docket is an approval workflow record, not approval itself.",
  "approvalSlotCount": 7,
  "approvedSlotCount": 0,
  "blockedSlotCount": 7,
  "releaseApprovalAllowed": false,
  "customerDeliveryAllowed": false,
  "commercialUseAllowed": false,
  "markdownPath": "public/beta-review-docket.md",
  "markdownHash": "sha256-142ac7820bf527022ca8d9232d80bf8834222c3eb3add92818d5333af335764c",
  "evidenceHashes": {
    "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
    "customerReportPacketLedger": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
    "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
    "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
    "uiFidelityLedger": "sha256-857d823d3c191fe56b18c0fbf5c3c1fdffa61d86ed2ca03009a76bb5113f1e58",
    "uiFidelityApprovalPacket": "sha256-a9ebbc25e00bd64e0c64d0dee15a0a7d2e2241270ff75c11ba09c6c81568bdb6"
  },
  "approvalSlots": [
    {
      "id": "owner-ui-fidelity-approval",
      "label": "Owner UI fidelity approval",
      "owner": "Product owner",
      "state": "human-approval-required",
      "approvalAllowed": false,
      "requiredProof": "Owner confirms the six accepted mockup pages match the intended review standard on desktop and mobile with no material omissions.",
      "currentEvidence": {
        "readinessScore": 90,
        "targetScore": 98,
        "uiFidelityLedgerHash": "sha256-857d823d3c191fe56b18c0fbf5c3c1fdffa61d86ed2ca03009a76bb5113f1e58",
        "requiredPageCount": 6,
        "referenceImageCount": 6,
        "renderedCaptureCount": 6,
        "automatedEvidenceCompleteCount": 6,
        "uiFidelityApprovalPacketHash": "sha256-a9ebbc25e00bd64e0c64d0dee15a0a7d2e2241270ff75c11ba09c6c81568bdb6",
        "uiFidelityReviewHtmlPath": "public/ui-fidelity-review/index.html",
        "uiFidelityReviewPageCount": 6,
        "ownerApprovalAllowed": false,
        "browserRegressionState": "automated-render-checks-pass-but-human-fidelity-approval-missing"
      },
      "linkedArtifactHashes": {
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "uiFidelityLedger": "sha256-857d823d3c191fe56b18c0fbf5c3c1fdffa61d86ed2ca03009a76bb5113f1e58",
        "uiFidelityApprovalPacket": "sha256-a9ebbc25e00bd64e0c64d0dee15a0a7d2e2241270ff75c11ba09c6c81568bdb6"
      },
      "nextAction": "Capture owner screenshot approval against the accepted six-page reference set.",
      "slotHash": "sha256-e81f71f8d5b7e2f70e0f1b84e79a4489e577bd7b055e90a56ed1342405bed2f0"
    },
    {
      "id": "source-use-commercial-clearance",
      "label": "Source-use commercial clearance",
      "owner": "Legal/source review",
      "state": "blocked-source-use-review",
      "approvalAllowed": false,
      "requiredProof": "Each source has customer/commercial use policy reviewed before report redistribution or derived-value claims are sold.",
      "currentEvidence": {
        "sourceCount": 33,
        "blockedSourceUseCount": 33,
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "linkedArtifactHashes": {
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "customerReportPacketLedger": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c"
      },
      "nextAction": "Review and approve source-use packets source by source before customer report delivery.",
      "slotHash": "sha256-7d8b4b14f0d11889079d0f04e31c425c8e6e960e91b190280055c105075cbab7"
    },
    {
      "id": "runtime-science-promotion",
      "label": "Runtime science promotion",
      "owner": "Science compute lead",
      "state": "blocked-runtime-promotion",
      "approvalAllowed": false,
      "requiredProof": "SPICE/Orekit/GMAT/Tudat/OpenMDAO outputs pass runtime artifact validation and independent review before mission-design claims promote.",
      "currentEvidence": {
        "contractCount": 5,
        "promotedRuntimeContractCount": 2,
        "blockedRuntimeContractCount": 3,
        "platformRuntimeReady": false
      },
      "linkedArtifactHashes": {
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c"
      },
      "nextAction": "Promote Orekit, GMAT, and Tudat runtime artifacts through the sidecar intake gate.",
      "slotHash": "sha256-5ead30324385202210a372715d20c7746286d5cb4293ee8cc7e7a255b1b5ad2a"
    },
    {
      "id": "customer-report-delivery-approval",
      "label": "Customer report delivery approval",
      "owner": "Research product lead",
      "state": "blocked-customer-delivery",
      "approvalAllowed": false,
      "requiredProof": "Every customer report packet has source-use, runtime, economics, resource, workspace, wording, and reviewer approval before delivery.",
      "currentEvidence": {
        "reportPacketCount": 3,
        "blockedReportPacketCount": 3,
        "reportExportCount": 3,
        "customerReadyReportPacketCount": 0
      },
      "linkedArtifactHashes": {
        "customerReportPacketLedger": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
        "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48"
      },
      "nextAction": "Use report packets for internal review and paid-beta scoping only until proof gates pass.",
      "slotHash": "sha256-5aa6adfcb8f8780607f43c7fbb14e774f3a3f78ec33ce9ebdc9ec2e43c9c4312"
    },
    {
      "id": "research-workspace-approval",
      "label": "Research workspace approval",
      "owner": "Research operations",
      "state": "blocked-workspace-review",
      "approvalAllowed": false,
      "requiredProof": "Each research workspace has reviewed scope, run refs, package refs, source refs, and closure actions before it is sold as a customer workstream.",
      "currentEvidence": {
        "workspaceCount": 3,
        "blockedWorkspaceCount": 3,
        "packageCount": 3,
        "blockedPackageCount": 3
      },
      "linkedArtifactHashes": {
        "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
        "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb"
      },
      "nextAction": "Assign reviewer and close workspace review gates per package lane.",
      "slotHash": "sha256-43f45e81535773334e99e98ac7bccbea1e6044b0f943389c72c02425d0384479"
    },
    {
      "id": "monitor-alert-recovery-proof",
      "label": "Monitor alert and recovery proof",
      "owner": "Release engineering",
      "state": "external-proof-required",
      "approvalAllowed": false,
      "requiredProof": "Real webhook or email relay receives exactly one failure alert after two forced failures and one recovery alert after target restoration.",
      "currentEvidence": {
        "gatedLiveScore": 96,
        "deploymentScore": 96,
        "proofState": "not-verified-with-real-webhook-or-email-relay"
      },
      "linkedArtifactHashes": {
        "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c"
      },
      "nextAction": "Attach a real alert endpoint, force two failures, restore target, and archive alert/recovery receipts.",
      "slotHash": "sha256-44165e57f9b308a5aab7452bf34d2f82f9abee856d93ab6962304975ef9e8814"
    },
    {
      "id": "release-manager-signoff",
      "label": "Release manager signoff",
      "owner": "Release manager",
      "state": "blocked-until-all-required-slots-pass",
      "approvalAllowed": false,
      "requiredProof": "All required signoff slots are approved with hashes, receipts, and release notes before claiming public/customer beta readiness.",
      "currentEvidence": {
        "readinessBlockingCount": 4,
        "lowestReadinessScore": 90,
        "releaseBoundary": "cannot approve while any slot approvalAllowed is false"
      },
      "linkedArtifactHashes": {
        "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "customerReportPacketLedger": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
        "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c"
      },
      "nextAction": "Approve only after owner UI, source-use, runtime science, customer delivery, workspace, and alert proof slots pass.",
      "slotHash": "sha256-3e0e53c8891e5c8ed3e7dd824732d661cf37c75747d7bcc63c5c5d14ce8bf3b0"
    }
  ],
  "docketHash": "sha256-e0c986eb0390db2490b64e5908012bf58f21fd8008f1c54fe84db3775d7123dc"
}
;
